module.exports = __webpack_public_path__ + "media/application/images/svgs/menu-aa533a34aa47b85cb180e805b03854c6.svg";